export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Two-Factor-Auth-Gray-92c41963342db1ebc789409180b3ad46.svg";